import actions from '../action/search'
import CONSTANT from '../constant/search'
import op from 'object-path'

const searchText = ''
const historyList = []
const hotWords = []
const defaultResult = {
  page: {
    total: 0
  },
  list: []
}
const searchResult = defaultResult
const searchResultV2 = defaultResult
const searchResultV3 = defaultResult
const recommendProduct = {
  page: {
    total: 0
  },
  list: []
}
export default {
  actions,
  state: {
    searchText,
    historyList,
    searchResult,
    searchResultV2,
    searchResultV3,
    hotWords,
    recommendProduct,
    shadings: [],
  },
  mutations: {
    [CONSTANT.SEARCH_CHANGE_TEXT] (state, value) {
      return state.searchText = value
    },
    [CONSTANT.SEARCH_GET_HISTORY_SUCCESS] (state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.SEARCH_GET_HISTORY_ERROR] (state, e) {
      return state.historyList = []
    },
    [CONSTANT.SEARCH_SET_HISTORY_SUCCESS] (state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.SEARCH_SET_HISTORY_ERROR] (state, e) {
      return state.historyList = []
    },
    [CONSTANT.SEARCH_CLEAR_HISTORY_SUCCESS] (state, list) {
      return state.historyList = []
    },
    [CONSTANT.SEARCH_CLEAR_HISTORY_ERROR] (state, e) {
      return state
    },
    [CONSTANT.SEARCH_REMOVE_HISTORY_SUCCESS] (state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.SEARCH_REMOVE_HISTORY_ERROR] (state, e) {
      return state
    },
    [CONSTANT.SEARCH_GET_RESULT_SUCCESS] (state, result) {
      return state.searchResult = result
    },
    [CONSTANT.SEARCH_GET_RESULT_START] (state) {
      return state.searchResult = { page: {total: 0}, list: []}
    },
    [CONSTANT.SEARCH_GET_RESULT_ERROR] (state, e) {
      return state.searchResult = { page: {total: 0}, list: []}
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS] (state, result) {
      return state.searchResult = {...result, ...{list: [...state.searchResult.list, ...result.list]}}
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_ERROR] (state, e) {
      return state.searchResult
    },
    [CONSTANT.SEARCH_GET_RESULT_SUCCESS_V2](state, result) {
      return state.searchResultV2 = result
    },
    [CONSTANT.SEARCH_GET_RESULT_START_V2](state) {
      return state.searchResultV2 = { page: { total: 0 }, list: [] }
    },
    [CONSTANT.SEARCH_GET_RESULT_ERROR_V2](state, e) {
      return state.searchResultV2 = { page: { total: 0 }, list: [] }
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS_V2](state, result) {
      return state.searchResultV2 = { ...result, ...{ list: [...state.searchResultV2.list, ...result.list] } }
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_ERROR_V2](state, e) {
      return state.searchResultV2
    },

    [CONSTANT.SEARCH_GET_RESULT_SUCCESS_V3](state, result) {
      return state.searchResultV3 = result
    },
    [CONSTANT.SEARCH_GET_RESULT_START_V3](state) {
      return state.searchResultV3 = { page: { total: 0 }, list: [] }
    },
    [CONSTANT.SEARCH_GET_RESULT_ERROR_V3](state, e) {
      return state.searchResultV3 = { page: { total: 0 }, list: [] }
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS_V3](state, result) {
      return state.searchResultV3 = { ...result, ...{ list: [...state.searchResultV3.list, ...result.list] } }
    },
    [CONSTANT.SEARCH_GET_RESULT_MORE_ERROR_V3](state, e) {
      return state.searchResultV3
    },
    // 底纹，热搜词
    [CONSTANT.SEARCH_GET_SHADING_HOTWORDS_SUCCESS](state, data) {
      state.shadings = op.get(data, 'shadings') || []// 1.7.6 版本取列表第一个
      state.hotWords = op.get(data, 'hots') || []
    },
    // 搜索词
    [CONSTANT.SEARCH_GET_HOT_WORDS_SUCCESS](state, data) {
      return state.hotWords = data.hotWords
    },
    [CONSTANT.SEARCH_GET_HOT_WORDS_ERROR](state, data) {
      return state.hotWords = []
    },
    // 热门商品推荐
    [CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_SUCCESS](state, data) {
      return state.recommendProduct = data
    },
    [CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_ERROR] (state) {
      return state.recommendProduct = {list: [], page: {total: 0}}
    },
    [CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_MORE_SUCCESS] (state, data) {
      return state.recommendProduct = {...data, ...{list: [...state.recommendProduct.list, ...data.list]}}
    },
    [CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_MORE_ERROR] (state) {
      return state.recommendProduct
    }

  }
}
